import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, IconButton, Tooltip } from '@material-ui/core';
import { hasPermission, hasAtLeastOnePermission, formatDate, createHistory } from '../../sc-utilities';
import SecurazeToolsList from './SecurazeToolList';
import { CloudDownload, FindInPage } from '@material-ui/icons';
import {download} from '../../sc-utilities/download.utils';
import { Redirect } from 'react-router-dom';
import config from "../../../config/config";
import {snackActions} from "../../sc-utilities/SnackBar";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const SecurazeTools = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions, activeCustomerID } = props;
    let visible = columns && columns['SecurazeTools'];
    const [redirectOptions, setRedirectOptions] = useState({
        redirect: false,
        securazeToolID: null,
        redirectPath: '',
    });

    const handleDownload = async (toolID) => {
        const objectURL = `${config.backend_domain}:${config.backend_port}/securaze-tools/download?SecurazeToolID=${toolID}&ActiveCustomerID=${activeCustomerID}`;
        let exportDataSuccessful = await download(objectURL);
        tableRef.current && tableRef.current.onQueryChange();
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    };

    const redirectToolsEdit = (event) => {
        createHistory();
        setRedirectOptions({
            redirect: true,
            securazeToolID: event.currentTarget.getAttribute('value'),
            redirectPath: `/downloads/securazeTool/edit?tools=${event.currentTarget.getAttribute('value')}`,
        });
    };

    const redirectToolsCreate = (path) => {
        createHistory();
        setRedirectOptions({
            redirect: true,
            securazeToolID: null,
            redirectPath: path,
        });
    };

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {hasPermission(permissions, 'securaze_tool_load') ?
                    <Tooltip title={translations['details_securaze_tool'] || "Securaze tool details"}>
                        <IconButton value={rowData.SecurazeToolID} aria-label={translations['details_securaze_tool'] || "Securaze tool details"} onClick={redirectToolsEdit}>
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                    : null}
                {hasPermission(permissions, 'securaze_tool_download') ?
                    <Tooltip title={translations['download_tool'] || "Download tool"}>
                        <IconButton components={'div'} value={rowData.SecurazeToolID} aria-label={translations['download_tool'] || "Download tool"} onClick={() => handleDownload(rowData.SecurazeToolID, `${rowData.OriginalFileName}`)}>
                            <CloudDownload />
                        </IconButton>
                    </Tooltip>
                    : null}
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ToolName ? rowData.ToolName : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["tool_type"] || 'Tool type', field: 'Status',
            hidden: visible ? visible['Status'] : false,
            filtering: true,
            lookup: { 'test': translations['test'] || 'Test', 'release': translations['release'] || 'Release', 'demo': translations['demo'] || 'Demo' },
            defaultFilter: ['release', 'test', 'demo'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Status ? rowData.Status : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["created_by"] || 'Created by', field: 'CreatedBy',
            hidden: visible ? visible['CreatedBy'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.User && rowData.User.Username ? rowData.User.Username : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["created_at"] || 'Created at', field: 'CreatedAt',
            hidden: visible ? visible['CreatedAt'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.CreatedAt ? formatDate(rowData.CreatedAt) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        }
    ];

    if (!hasAtLeastOnePermission(permissions, ['securaze_tool_download', 'securaze_tool_load'])) {
        tableColumns.shift();
    }

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'securaze_tool_list') ?
                <SecurazeToolsList
                    redirectHandler={redirectToolsCreate}
                    tableColumns={tableColumns}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(SecurazeTools));